import { render, staticRenderFns } from "./allList.vue?vue&type=template&id=b246a32c&scoped=true"
import script from "./allList.vue?vue&type=script&lang=js"
export * from "./allList.vue?vue&type=script&lang=js"
import style0 from "./allList.vue?vue&type=style&index=0&id=b246a32c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b246a32c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b246a32c')) {
      api.createRecord('b246a32c', component.options)
    } else {
      api.reload('b246a32c', component.options)
    }
    module.hot.accept("./allList.vue?vue&type=template&id=b246a32c&scoped=true", function () {
      api.rerender('b246a32c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/claimRecordManage/allList.vue"
export default component.exports